import { IconProps } from "./";
import Icon from "./assets/patent_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Patent(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
